export const EVENT_TYPES_ENUM = {
  Save: 1,
  Continue: 2,
  VideoPlay: 12,
  VideoPause: 13,
  VideoEnd: 14,
};
